import React from "react";
import { Container } from "components/common";
import { Wrapper, Details } from "./styles";
export const Accomplishments = () => {
     return (
    <div>
      <Wrapper as={Container} id='accomplishment'>
        <h1><u>Accomplishments:</u></h1>
        <Details as={Container} id='acc_bos'>
          <div className='containers'>
              
            
            <div className='skill_box'>
              <div className='skill_title'>
                
                <h2><u>TCS CODEVITA<i>( SEASON 9):</i></u><br></br><br></br>
                <h3> I was cleared in first round of codevita season 9. </h3></h2>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            <hr></hr>
               <div className='skill_box'>
              <div className='skill_title'>
                
                <h2><u>ZENSAR TECHNOLOGIEAS</u> <br></br><br></br>
                <i> TRAINING AND PLACEMENT PROGRAM :</i><br></br><br></br>
                <h3> I was selected for free training and placement program from ZENSAR.</h3></h2>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
          </div>
        </Details>
      </Wrapper>
    </div>
  );
};